import { Grid, Grow, styled, Typography } from "@mui/material";
import { Activity } from "api/types";
import clsx from "clsx";
import { SimpleActivityCard } from "components/SimpleActivityCard";
import { useEffect, useRef, useState } from "react";

const PREFIX = "PreviewSelectedActivity";

const classes = {
	previewContainer: `${PREFIX}-previewContainer`,
	closeBtn: `${PREFIX}-closeBtn`,
	hiddenContainer: `${PREFIX}-hiddenContainer`,
	title: `${PREFIX}-title`,
};

const StyledGrow = styled(Grow)(({ theme }) => ({
	[`& .${classes.previewContainer}`]: {
		borderRadius: 4,
		backgroundColor: theme.palette.background.paper,
		padding: theme.spacing(2),
		margin: theme.spacing(1),
		width: "inherit",
	},

	[`& .${classes.closeBtn}`]: {
		backgroundColor: theme.palette.grey[100],
	},

	[`& .${classes.hiddenContainer}`]: {
		height: "0px",
	},

	[`& .${classes.title}`]: {
		fontWeight: "bold",
	},
}));

export interface PreviewSelectedActivityProps {
	selected: Activity[];
	handler?: (activities: Activity[]) => void;
	show: boolean;
	mode: "edit" | "create";
}

export const PreviewSelectedActivity = ({
	selected,
	handler,
	show,
	mode,
}: PreviewSelectedActivityProps): JSX.Element => {
	const [existing, setExisting] = useState<Activity[]>([]);
	const initialLoad = useRef(true);
	const handleDelete = (item: Activity): void => {
		if (selected.includes(item)) {
			handler?.(selected.filter((activity) => item !== activity));
		}
	};

	// This will handle the parent component updating the prop via and API call
	// to fetch the existing activities for created assignment
	useEffect(() => {
		// Logic to ensure when editing, we fetch the list of already
		// selected activities and exclude them from being able to be
		// deleted
		if (mode === "edit" && initialLoad.current && selected.length > 0) {
			setExisting(selected);
			initialLoad.current = false;
		}
	}, [selected, mode]);

	return (
		<StyledGrow in={selected.length !== 0} timeout={1000}>
			<Grid
				container
				justifyContent="flex-start"
				className={clsx(
					selected.length !== 0
						? classes.previewContainer
						: classes.hiddenContainer,
				)}
			>
				<Grid item xs={12}>
					<Typography className={classes.title}>Selected Assignment</Typography>
				</Grid>
				{selected.map((item) => (
					<Grow key={item.questId.toString() + item.activityType} in>
						<SimpleActivityCard
							show={
								!existing.some(
									(item2) =>
										item.activityType === item2.activityType &&
										item.name === item2.name,
								) && show
							}
							activity={item}
							remove={() => handleDelete(item)}
						/>
					</Grow>
				))}
			</Grid>
		</StyledGrow>
	);
};
